module.exports = __webpack_public_path__ + "img/novi-crveni-legal.b13577b7.svg";